var _style, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgILogoff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "BG",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF5400;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 35,
    cy: 35,
    r: 13
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 34.1,
    y: 24.5,
    className: "st1",
    width: 2,
    height: 8.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.1,27.3v2.1c2.3,0.9,3.9,3,3.9,5.6c0,3.3-2.7,6-6,6s-6-2.7-6-6c0-2.7,1.7-4.9,4.1-5.7v-2.1 C29.6,28,27,31.2,27,35c0,4.4,3.6,8,8,8s8-3.6,8-8C43,31.3,40.5,28.2,37.1,27.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgILogoff);
export default __webpack_public_path__ + "static/media/i_logoff.f2adc74c7b6191ae94b469711e578919.svg";
export { ForwardRef as ReactComponent };